import { globalCss } from './stitches.config'

export const globalStyles = globalCss({
    '@import':
        "url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400;1,600;1,700&display=swap')",
    '*': {
        boxSizing: 'inherit',

        '&::before, &::after': {
            boxSizing: 'inherit',
        },
    },
    'article, aside, details, figcaption, figure, footer, header, hgroup, main, menu, nav, section':
        {
            display: 'block',
        },
    'h1, h2, h3, h4, h5, h6': {
        lineHeight: 1.1,
        fontFamily: '$default',
        fontWeight: 400,
        m: 0,
    },
    html: {
        boxSizing: 'border-box',
        direction: 'ltr',
        fontSize: '100%',
        overscrollBehaviorY: 'none',
        lineHeight: 1.15,
        textSizeAdjust: '100%',
    },
    body: {
        bgc: '$white',
        color: '$black',
        fontFamily: '$default',
        fontWeight: 400,
        lineHeight: 1.5,
        m: 0,
        unicodeBidi: 'embed',
    },
    '*[hidden]': {
        display: 'none',
    },
    'button, input, optgroup, select, textarea': {
        fontFamily: '$default',
        fontSize: '100%',
        lineHeight: 1.1,
        m: 0,
    },
    'button, [type="button"], [type="reset"], [type="submit"]': {
        appearance: 'button',
    },
    'button::-moz-focus-inner, [type="button"]::-moz-focus-inner, [type="reset"]::-moz-focus-inner, [type="submit"]::-moz-focus-inner':
        {
            borderStyle: 'none',
            p: 0,
        },
    'button:-moz-focusring, [type="button"]:-moz-focusring, [type="reset"]:-moz-focusring, [type="submit"]:-moz-focusring':
        {
            outline: '1px dotted ButtonText',
        },
    'ol, ul': {
        listStyle: 'none',
    },
    'blockquote, q': {
        quotes: 'none',
    },
    'blockquote:before, blockquote:after, q:before, q:after': {
        content: `''`,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        content: 'none',
    },
    table: {
        borderSpacing: 0,
    },
})
